import {
  Directive,
  Input,
  HostBinding,
  HostListener,
  NgZone,
  OnInit,
  OnDestroy,
  ElementRef
} from '@angular/core';

import { Observable } from 'rxjs';

import { DropdownService } from './dropdown.service';
import {takeWhile} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';


@Directive({
  selector: '[dropdownItem]',
  exportAs: 'dropdown-item'
})
export class DropdownItemDirective implements OnInit, OnDestroy {

  /**
   * Dropdown menu alignment
   * https://v4-alpha.getbootstrap.com/components/dropdowns/#menu-alignment
  */
  @HostBinding('class.dropdown-item') dropownItem: boolean = true;

  private isActive: boolean = true;

  constructor(
    private dropdownService: DropdownService,
    private ngZone: NgZone,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(this.elementRef.nativeElement, 'click')
      .pipe(takeWhile(() => this.isActive))
      .subscribe((event: MouseEvent) => {
        this.dropdownService.close();
      });
    });
  }

  ngOnDestroy() {
    this.isActive = false;
  }
}
